import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { NavLink, matchPath } from 'react-router-dom';
import DangerousHTML from 'react-dangerous-html';
import classNames from 'classnames';

class MenuList extends PureComponent {
  render() {
    const { location, links } = this.props;
    const isActiveLink = (link, { pathname }) => matchPath(pathname, { path: link, exact: true, strict: true });

    return (
      <ul>
        {links.map(({ pathname, label, children }) => {
          const className = classNames({
            '-has-dropdown': !!children,
            '-active': (pathname && isActiveLink(pathname, location))
            || (!!children && isActiveLink(children.map(p => p.pathname !== '/'), location))
          });
          return (
            <li key={`${pathname}${label.toLowerCase()}`} className={className}>
              {
                pathname
                  ? <NavLink to={pathname}><DangerousHTML html={label} /></NavLink>
                  : <span><DangerousHTML html={label} /></span>
              }
              {
                children && (
                  <div className={`dropdown -${label.toLowerCase()}`}>
                    <ul>
                      {children.map((c) => {
                        const childrenClassName = classNames({
                          '-active': c.pathname
                            && isActiveLink(c.pathname, location),
                        });
                        return (
                          <li
                            key={`${c.pathname}${c.label.toLowerCase()}`}
                            className={childrenClassName}
                          >
                            <NavLink to={c.pathname}>
                              <DangerousHTML html={c.label} />
                            </NavLink>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                )
              }
            </li>
          );
        })}
      </ul>
    );
  }
}

MenuList.propTypes = {
  location: PropTypes.shape({ pathname: PropTypes.string }).isRequired,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      pathname: PropTypes.string,
      label: PropTypes.string,
      onlyMobile: PropTypes.bool,
      children: PropTypes.array,
    }),
  ).isRequired,
};

export default MenuList;



// WEBPACK FOOTER //
// ./src/app/main-nav/menu-list/index.js